import axiosClient from './axiosClient';

export const companyAssessmentCertificatesService = {
  create: (certificate) => axiosClient.post('/company-assessment-certificates/', certificate),
  list: (params) => axiosClient.get('/company-assessment-certificates/', { params }),
  get: (id) => axiosClient.get(`/company-assessment-certificates/${id}/`),
  delete: (id) => axiosClient.delete(`/company-assessment-certificates/${id}/`),
  downloadPdf: (id) => axiosClient.get(`/company-assessment-certificates/${id}/pdf/`, {
    responseType: 'blob'
  }),
  generatePdf: (id) => axiosClient.post(`/company-assessment-certificates/${id}/generate-pdf/`)
};
